module.exports = __webpack_public_path__ + "static/img/share03.d2859ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share03.png
// module id = oDAj
// module chunks = 1